import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import { TextField } from "@material-ui/core";
import moment from "moment";
import Swal from "sweetalert2";
import BetterBox from "../../../components/BetterBox";
import BetterSelect from "../../../components/BetterSelect";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import { getDashboard } from "../../../crud/dashboard.crud";
import { getSimpleList } from "../../../crud/closer.crud";
import BetterCircularProgress from "../../../components/BetterCircularProgress";

const MOCK_KPIS = {
    taxa_match_util: 68,
    taxa_conversao: 53,
    tempo_handoff: 10,
    tempo_demanda: 45,
};

const MOCK_NEGOCIACOES = [35, 40, 46, 40, 42, 44, 39, 41, 43, 38, 31, 30, 33];

const MESES_ABREV = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

const buildChartLabels = () => {
    const labels = [];

    for (let i = 12; i >= 0; i--) {
        const m = moment().subtract(i, "months");
        labels.push(`${MESES_ABREV[m.month()]}/${m.year()}`);
    }

    return labels;
};

const chartData = {
    labels: buildChartLabels(),
    datasets: [
        {
            label: "Negociações finalizadas",
            data: MOCK_NEGOCIACOES,
            borderColor: "rgb(17, 61, 255)",
            backgroundColor: "transparent",
            pointBackgroundColor: "rgb(17, 61, 255)",
            pointBorderColor: "rgb(17, 61, 255)",
            pointRadius: 4,
            borderWidth: 2,
            lineTension: 0.3,
        },
    ],
};

const chartOptions = {
    legend: { display: false },
    tooltips: { mode: "index", intersect: false },
    scales: {
        xAxes: [{ gridLines: { display: false } }],
        yAxes: [{ gridLines: { color: "#eee" }, ticks: { beginAtZero: true } }],
    },
};

export default class DashboardPage extends Component {
    constructor() {
        super();

        this.state = {
            loading: false,
            submitted: false,
            filtros: {
                data_inicio: moment().format("YYYY-MM-DD"),
                data_fim: moment().format("YYYY-MM-DD"),
                closer_id: "",
            },
            closers: [],
            data: null,
        };
    }

    componentDidMount = () => {
        this.setState({ loading: true });

        Promise.all([getDashboard(this.state.filtros), getSimpleList()])
            .then(([resDashboard, resClosers]) => {
                if (resDashboard.data.errors) {
                    return Swal.fire("Ops!", resDashboard.data.errors[0], "error");
                }

                this.setState({
                    loading: false,
                    data: { ...MOCK_KPIS, ...resDashboard.data },
                    closers: resClosers.data ?? [],
                });
            })
            .catch(() => Swal.fire("Ops!", "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error"));
    };

    onSubmit = () => {
        if (this.state.filtros.data_inicio > this.state.filtros.data_fim) {
            return Swal.fire("Ops!", "A data final não pode ser anterior a data inicial.", "warning");
        }

        this.setState({ submitted: true }, () => {
            getDashboard(this.state.filtros)
                .then((res) => {
                    if (res.data.errors) {
                        this.setState({ submitted: false });
                        return Swal.fire("Ops!", res.data.errors[0], "error");
                    }

                    this.setState({ submitted: false, data: { ...MOCK_KPIS, ...res.data } });
                })
                .catch(() => {
                    this.setState({ submitted: false });
                    Swal.fire("Ops!", "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                });
        });
    };

    render() {
        return (
            <BetterCircularProgress loading={this.state.loading}>
                <BetterBox title="Filtros">
                    <Row>
                        <Col sm={4}>
                            <TextField
                                label="Data de início"
                                type="date"
                                variant="outlined"
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                                value={this.state.filtros.data_inicio}
                                onChange={(e) => this.setState({ filtros: { ...this.state.filtros, data_inicio: e.target.value } })}
                            />
                        </Col>

                        <Col sm={4}>
                            <TextField
                                label="Data de fim"
                                type="date"
                                variant="outlined"
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                                value={this.state.filtros.data_fim}
                                onChange={(e) => this.setState({ filtros: { ...this.state.filtros, data_fim: e.target.value } })}
                            />
                        </Col>

                        <Col sm={4}>
                            <BetterSelect
                                label="Closer"
                                labelWidth={47}
                                blankOption
                                name="closer_id"
                                value={this.state.filtros.closer_id}
                                onChange={(e) => this.setState({ filtros: { ...this.state.filtros, closer_id: e.target.value } })}
                            >
                                {this.state.closers.map((closer) => (
                                    <option key={closer.id} value={closer.id}>
                                        {closer.use_name}
                                    </option>
                                ))}
                            </BetterSelect>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={2}>
                            <button type="button" className="btn btn-success btn-bold" disabled={this.state.submitted} onClick={this.onSubmit}>
                                <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>Aplicar
                            </button>
                        </Col>
                    </Row>
                </BetterBox>

                <BetterCircularProgress loading={this.state.submitted}>
                    <div className="row">
                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <Portlet className="kt-portlet--border-bottom-brand mb-0" style={{ borderBottom: "4px solid rgb(17, 61, 255)" }} fluidHeight={true}>
                                <PortletBody>
                                    <div className="kt-widget26">
                                        <div className="kt-widget26__content">
                                            <span className="kt-widget26__desc pb-0">Taxa de match útil</span>

                                            <span className="kt-widget26__number">{this.state.data?.taxa_match_util ?? 0}%</span>
                                        </div>
                                    </div>
                                </PortletBody>
                            </Portlet>
                        </div>

                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <Portlet className="kt-portlet--border-bottom-brand mb-0" style={{ borderBottom: "4px solid rgb(17, 61, 255)" }} fluidHeight={true}>
                                <PortletBody>
                                    <div className="kt-widget26">
                                        <div className="kt-widget26__content">
                                            <span className="kt-widget26__desc pb-0">Taxa de conversão</span>

                                            <span className="kt-widget26__number">{this.state.data?.taxa_conversao ?? 0}%</span>
                                        </div>
                                    </div>
                                </PortletBody>
                            </Portlet>
                        </div>

                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <Portlet className="kt-portlet--border-bottom-brand mb-0" style={{ borderBottom: "4px solid rgb(17, 61, 255)" }} fluidHeight={true}>
                                <PortletBody>
                                    <div className="kt-widget26">
                                        <div className="kt-widget26__content">
                                            <span className="kt-widget26__desc pb-0">Tempo de handoff (min)</span>

                                            <span className="kt-widget26__number">{this.state.data?.tempo_handoff ?? 0}</span>
                                        </div>
                                    </div>
                                </PortletBody>
                            </Portlet>
                        </div>

                        <div className="col-sm-12 col-md-6 col-lg-3">
                            <Portlet className="kt-portlet--border-bottom-brand mb-0" style={{ borderBottom: "4px solid rgb(17, 61, 255)" }} fluidHeight={true}>
                                <PortletBody>
                                    <div className="kt-widget26">
                                        <div className="kt-widget26__content">
                                            <span className="kt-widget26__desc pb-0">Tempo de demanda (min)</span>

                                            <span className="kt-widget26__number">{this.state.data?.tempo_demanda ?? 0}</span>
                                        </div>
                                    </div>
                                </PortletBody>
                            </Portlet>
                        </div>
                    </div>

                    <BetterBox title="Negociações finalizadas">
                        <div style={{ height: 400 }}>
                            <Line data={chartData} options={chartOptions} />
                        </div>
                    </BetterBox>
                </BetterCircularProgress>
            </BetterCircularProgress>
        );
    }
}